<template>
    
    <b-row class="slide-body">
        <b-col cols="1">
            <b-img @click="goToSlide('slide23')" left src="@/images/button-left.png" :title="$t('general.previous')" fluid></b-img>
        </b-col>

        <b-col cols="10">
            <b-row >  
                <b-row align-h="center" class="pt-1 pb-1">   
                    <h1 style="color:#ffffff"><strong>{{ $t('slide24.text1') }}</strong></h1>
                </b-row>
                <b-row align-h="center" class="pb-2">                           
                    <b-col cols="4">                                                   
                        <div class="contenedor">                
                            <b-img align="bottom" src="@/images/slide24-bubble-1.png" fluid></b-img>
                            <div class="texto-centrado"><h5><strong>{{ $t('slide24.text2') }}</strong></h5></div>
                        </div>
                        <b-img align="bottom" src="@/images/slide24-tronic.png" fluid></b-img>
                    </b-col>
                    <b-col cols="8"> 
                        <b-card class="text-center" :class="SetScroll">                       
                            <b-row>                            
                                <b-card-text align="justify">{{ $t('slide24.text3') }}</b-card-text>
                            </b-row>
                            <b-row>                            
                                <b-card-text align="justify">{{ $t('slide24.text4') }}</b-card-text>
                            </b-row>
                            <b-row>                            
                                <b-card-text align="justify">{{ $t('slide24.text5') }}</b-card-text>
                            </b-row>
                            <b-row>                            
                                <b-card-text align="justify">{{ $t('slide24.text6') }}</b-card-text>
                            </b-row>
                            <b-row>
                                <b-card-text align="justify">{{ $t('slide24.text7') }}</b-card-text>
                            </b-row>
                            <b-row class="pt-3">
                                <b-card-text align="justify">{{ $t('slide24.text8') }}</b-card-text>
                            </b-row> 
                            <b-row class="pt-3">
                                <b-card-text align="justify"><strong>{{ $t('slide24.text9') }}</strong></b-card-text>
                            </b-row>
                            <b-row>
                                <b-card-text align="justify"><strong>{{ $t('slide24.text10') }}</strong></b-card-text>
                            </b-row>
                            <b-row>                        
                                <b-card-text align="justify"><strong>{{ $t('slide24.text11') }}</strong></b-card-text>
                            </b-row>                           
                        </b-card>
                        <b-row align-h="center" class="pt-2">   
                            <b-button size="lg" variant="dark"  @click.stop.prevent="playSound">
                                <h5 style="color:#ffffff">
                                    <strong><font-awesome-icon :icon="iconName" /> {{ $t('slide24.text12') }}</strong>
                                </h5>
                            </b-button>
                        </b-row>
                    </b-col>                       
                </b-row>            
            </b-row>                 
        </b-col>

        <b-col cols="1">
           <b-img  @click="goToSlide('slide25')" right src="@/images/button-right.png" :title="$t('general.next')" fluid></b-img>
        </b-col>
    </b-row>         

</template>

<script>
import {mapState} from 'vuex';

export default {
    props:['lang'],
    data() {
        return {
            audios: {
                es: require('@/audios/es_slide24_audio.mp4'),
                ca: require('@/audios/ca_slide24_audio.mp4')
            },            
            playStatus: "stopped",     
            audioPlaying:  null 
       }
    }, 
    computed:{
        ...mapState(['showMenu']),
        iconName(){
            if(this.playStatus == "playing"){
                return "pause";
            }else{
                return "play";
            }
        },
         SetScroll(){
            if(this.$mq==='desktop'){
                return 'text-center';
            }else{
                return 'text-center scroll';
            } 
        }
    },
    methods:{
         goToSlide(slide){
            if(this.playStatus == "playing"){
                this.playStatus = "paused";
                this.audioPlaying.pause();
                this.audioPlaying=null;
            }
            this.$router.push({name:slide,params:{lang:this.lang}});
        },
        playSound(){
            if(this.audioPlaying == null){
                this.audioPlaying = new Audio(this.audios[this.$i18n.locale]);
            }

            if(this.playStatus == "playing"){
                this.playStatus = "paused";
                this.audioPlaying.pause();
            }else if(this.playStatus == "paused" || this.playStatus == "stopped"){
                this.playStatus = "playing";
                this.audioPlaying.play();
                this.audioPlaying.addEventListener('ended', this.audioEnd);
            }          
        },
        audioEnd(){
            this.playStatus = "stopped";           
        }
    },     
    beforeCreate(){
        this.$store.dispatch('changeShowMenu',true);
    },
    created(){
        this.$i18n.locale=this.lang;
    }    
}
</script>


<style scoped>

    .row{
        margin-left: 0px;
        margin-right: 0px;  
        position:relative; 
        width: 100%; 
    }

    .scroll{
       max-height: 400px;
       overflow-y: auto;
    }

    .contenedor{
        position: relative;
        display: inline-block;
        text-align: center;
    }
    
    .texto-centrado{
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -60%);
    }   

</style>